import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import Title from '../../../components/Title';
import Breadcrumbs from '../../../components/Breadcrumbs';
import KeywordFilter from './dataGrid/KeywordFilter';
import KeywordDataGrid from './dataGrid/KeywordDataGrid';
import SnackbarSettings from '../../../components/Snackbar/SnackbarSettings';
import * as Actions from '../redux/keywordActions';
import * as Selectors from '../redux/keywordSelectors';

const breadcrumbs = [
  {
    label: 'keyword.list',
    to: null,
  },
];

const KeywordList: React.FC = () => {
  const { t } = useTranslation();
  const apiRequestState = useSelector(Selectors.apiKeywordsRequestState);
  const apiRequestError = useSelector(Selectors.apiKeywordsRequestError);

  return (
    <>
      <SnackbarSettings
        hideSuccessMessage={true}
        apiRequestState={apiRequestState}
        apiRequestError={apiRequestError}
        setApiRequestState={Actions.setApiKeywordsRequestState}
      />
      <Title>{t('keyword.list')}</Title>
      <Breadcrumbs title="keyword.list" links={breadcrumbs} hide />
      <KeywordFilter />
      <KeywordDataGrid />
    </>
  );
};

export default KeywordList;
